import React, { useState } from 'react';
import { Mail, Lock, ArrowRight, CheckSquare } from 'lucide-react';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await onLogin(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-form-box">
        <div className="logo-box">
          <img 
            src="/redstone-logo-transparent.png" 
            alt="Redstone Nexus" 
            className="hero-logo"
          />
        </div>
        
        <h1 className="hero-title">Redstone Nexus</h1>
        <p className="hero-tagline">The Center of Ready</p>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">Email</label>
            <div className="input-wrapper">
              <Mail size={20} className="input-icon" />
              <input
                type="email"
                className="form-input"
                placeholder="you@redstone.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-wrapper">
              <Lock size={20} className="input-icon" />
              <input
                type="password"
                className="form-input"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
          </div>

          {error && (
            <div className="error-message" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary login-submit"
            disabled={loading}
            data-testid="login-submit"
          >
            {loading ? 'Signing in...' : (
              <>
                Sign In <ArrowRight size={20} />
              </>
            )}
          </button>
        </form>

        <div className="demo-box">
          <p className="demo-label">Demo</p>
          <p className="demo-text">admin@redstone.com / admin123</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
